<template>
  <div>
    <el-dialog :title='title' :visible.sync='open' width='1080px' append-to-body :close-on-click-modal='false'>
      <el-form ref='form' size='mini' :model='form' :rules='rules' label-position='right' label-width='120px'>
        <el-row :gutter='10'>
          <el-col :span='12' v-for='(col,key) in columns' :key='key'>
            <el-form-item :label='col.label' v-if='excludeFields.indexOf(col.prop)===-1'>
              <template v-if='col.data_type==="text"'>
                <el-input  v-model='form[col.prop]' :placeholder='col.placeholder||`请输入${col.label}相关信息`'
                           clearable />
              </template>
              <template v-else-if='col.data_type==="select"'>
                <el-select v-model='form[col.prop]' :placeholder='col.placeholder||`请选择${col.label}相关信`' clearable>
                  <el-option v-for='(option,key) in col.data_range' :key='`${col.prop}_${key}`' :value='option'
                             :label='option'></el-option>
                </el-select>
              </template>
              <template v-else>
                <el-input  v-model='form[col.prop]' :placeholder='col.placeholder||"请输入"'
                           clearable />
              </template>
              <!--              <el-input v-model='form[col.prop]' :placeholder='`${col.placeholder||col.label}`' clearable />-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <!--        <el-button @click='handleDemo'>示例</el-button>-->
        <el-button type='primary' @click='submitForm' :disabled='loadingCommit' :loading='loadingCommit'>确 定
        </el-button>
        <el-button @click='cancel'>取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveKolBasicRecord } from '@/api/kol_basic_record'

export default {
  name: 'ArtistBaseModulesCreateEdit',
  data() {
    return {
      loadingCommit: false,
      // 弹出层标题
      title: '录入红人基础数据',
      // 是否显示弹出层
      open: false,
      // 表单校验
      rules: {
        // artist_id: [{ required: true, message: '红人ID不能为空', trigger: 'blur' }],
        artist_nickname: [{ required: true, message: '红人昵称不能为空', trigger: 'blur' }]
        // platform_code: [{ required: true, message: '平台代号不能为空', trigger: 'blur' }],
        // content: [{ required: true, message: '数据JSON不能为空', trigger: 'blur' }],
        // is_show: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }]
      },
      // 表单参数
      form: {},
      excludeFields: ['dept_name']
    }
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    currPlatform: {
      type: Object
    }
  },
  methods: {
    show(data) {
      // this.form = {}
      this.title = `录入红人【${this.currPlatform.name}】基础数据`
      this.open = true
      this.loadingCommit = false
      this.form = { ...data }
    },
    /** 提交按钮 */
    async submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loadingCommit = true
          setTimeout(() => {
            this.loadingCommit = false
          }, 500)

          // let postData = {
          //   platform_code: this.currPlatform.code,
          //   nickname: this.form.nickname,
          //   content: JSON.stringify(this.form)
          // }
          this.form.platform_code = this.currPlatform.code
          this.form.platform_name = this.currPlatform.name
          saveKolBasicRecord(this.form).then(id => {
            if (id) {
              if (!this.form.id)
                this.msgSuccess('新增成功')
              else
                this.msgSuccess('修改成功')

              this.form.id = id
              this.open = false
              this.$emit('changed')
            } else {
              this.msgError('操作失败')
            }
            setTimeout(() => {
              this.loadingCommit = false
            }, 500)
          })

        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
    },
    handleDemo() {
      this.form = {
        nickname: '黑心少奶奶',
        home_page_link: 'https://www.xiaohongshu.com/user/profile/5d0c42fc000000001003ef53',
        total_fans: 233.2569
      }
      // this.columns.forEach((_fieldMap) => {
      //   this.form[_fieldMap.prop] = _fieldMap.label + (new Date()).getTime()
      // })
    }
  }
}
</script>

<style scoped>

</style>
